//@ts-strict-ignore
import React, { ComponentProps } from 'react';
import Workspace from '../../components/Workspace/Workspace';
import { Nominal } from '../../graphql/entities';
import Formatters from '../../components/grid-addons/formatters';
import fieldMetaData from '../../graphql/schema/fieldMetaData';
import { useWorkspace } from '../../graphql/hooks/useWorkspace';
import NominalForm from './NominalForm';
import { INominal, INominalEdge } from '../../graphql/schema/p4types';
import { Paths } from '../../@types/keyOfNested';
import { WorkspaceActionButtons } from '../../components/Workspace/WorkspaceActionButtons';
import { useNominalWorkspaceActions } from '../../actions/nominal/NominalWorkspaceAction';

const { formUrl, type, title, workspace } = Nominal;

const NOMINAL_COLUMN_OVERRIDES = {
  accountNo: {
    width: 150,
    formatter: Formatters.PrimaryFieldFormatter,
  },
  accountType: {
    name: 'Account Type',
    width: 140,
    options: fieldMetaData.AccountType,
    formatter: Formatters.EnumFormatter,
  },
  allowDirectPostings: {
    formatter: Formatters.BooleanFormatter,
    width: 100,
    name: 'Direct',
  },
  postingSuspended: {
    formatter: Formatters.BooleanFormatter,
    width: 100,
    name: 'Suspended',
  },
  'balance.baseBalance': {
    name: 'YTD Balance',
    formatter: Formatters.NumericFormatter,
    width: 120,
    cellClass: 'rightAlign',
  },
  'reportCategory.description': {
    name: 'Report Category',
  },
};

const NOMINAL_FIELD_NAMES: Array<Paths<INominal>> = [
  'accountNo',
  'name',
  'accountType',
  'reportCategory.description',
  'allowDirectPostings',
  'postingSuspended',
  'balance.baseBalance',
];

const NominalCellRenderer = ({ dependentValues }: { dependentValues: { rowData: INominalEdge } }) => {
  if (!dependentValues.rowData) return <div />;
  const { accountNo, name } = dependentValues.rowData.node as INominal;

  return (
    <div>
      <div className="cell-primary">{accountNo}</div>
      <div className="cell-data">{name}</div>
    </div>
  );
};

const NominalWorkspaceActions = (props: Omit<ComponentProps<typeof WorkspaceActionButtons>, 'actionButtons'>) => {
  const [actions, modals] = useNominalWorkspaceActions();
  return (
    <>
      {modals}
      <WorkspaceActionButtons {...props} actionButtons={actions} />
    </>
  );
};

const NominalWorkspace = (props) => {
  const dashboard = ['accountNo', 'name', 'balance.baseBalance'];

  const workspaceProps = useWorkspace<INominal>(props, Nominal, {
    columns: NOMINAL_FIELD_NAMES,
    columnOverrides: NOMINAL_COLUMN_OVERRIDES,
    initialSortColumn: 'accountNo',
  });

  return (
    <Workspace
      entityType={type}
      dashboard={dashboard}
      title={title}
      formUrl={formUrl}
      cellRenderer={NominalCellRenderer}
      detailView={NominalForm}
      defaultQuery={workspace}
      duplicate={true}
      {...workspaceProps}
      {...props}
      entity={Nominal}
      workspaceActionButtonsHOC={NominalWorkspaceActions}
    />
  );
};

export default NominalWorkspace;
